import React from 'react';
import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./CarBrands.css";
import Subros from "../../assets/Car_Brands/subros.png";
import hanon from "../../assets/Car_Brands/hanon.png";
import denso from "../../assets/Car_Brands/denso.png";
import delphi from "../../assets/Car_Brands/delphi.png";
import nsk from "../../assets/Car_Brands/nsk.png";

gsap.registerPlugin(ScrollTrigger);

export const CarBrands = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    const logos = Array.from(containerRef.current.querySelectorAll("img"));

    const animateLogos = () => {
      gsap.fromTo(
        logos.slice(0, 3),
        { x: "-100%", opacity: 0 },
        {
          x: "0%",
          opacity: 1,
          duration: 1,
          ease: "power2.out",
          stagger: 0.2,
        }
      );

      gsap.fromTo(
        logos.slice(3),
        { x: "100%", opacity: 0 },
        {
          x: "0%",
          opacity: 1,
          duration: 1,
          ease: "power2.out",
          stagger: 0.2,
        }
      );
    };

    ScrollTrigger.create({
      trigger: containerRef.current,
      start: "bottom bottom",
      onEnter: animateLogos,
      onLeaveBack: () => ScrollTrigger.refresh(),
    });
  }, []);

  return React.createElement(
    "section",
    { className: "car-brands-section", id: "rent", ref: containerRef },
    React.createElement(
      "div",
      { className: "car-heading" },
      React.createElement("h4", null, "Our Partners")
    ),
    React.createElement(
      "div",
      { className: "logo-container" },
      React.createElement("img", { src: hanon, alt: "maruti" }),
      React.createElement("img", { src: Subros, alt: "Subros" }),
      React.createElement("img", { src: nsk, alt: "nsk" }),
      React.createElement("img", { src: denso, alt: "denso" }),
      React.createElement("img", { src: delphi, alt: "delphi" }),
      
    )
  );
};
